import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function Threshold(props) {
    //   const handleSubmit = (e) => {
    //     e.preventDefault();
    //     alert("Threshold data submitted!");
    //   };
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const navigate = useNavigate();

    const handleAddNew = () => {
        navigate("/add-new"); // Replace "/new-page" with your target route
    };


    return (
        <>
            <div className="container-fluid mt-60px">
                <div className="threshold-box p-3 mt-3">
                    <h5 className="mb-3 mt-3">Threshold</h5>

                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <form>
                                {/* Flex row for 5 selectors */}
                                <div
                                    className="d-flex flex-wrap gap-3"
                                    style={{ justifyContent: "space-between" }}
                                >
                                    <div style={{ flex: "1 1 18%" }}>
                                        <label className="form-label fw-semibold">Country</label>
                                        <select className="form-select">
                                            <option value="">Select Country</option>
                                            <option value="malawi">Malawi</option>
                                            <option value="zambia">Zambia</option>
                                            <option value="tanzania">Tanzania</option>
                                        </select>
                                    </div>

                                    <div style={{ flex: "1 1 18%" }}>
                                        <label className="form-label fw-semibold">Region</label>
                                        <select className="form-select">
                                            <option value="">Select Region</option>
                                            <option value="north">Northern</option>
                                            <option value="south">Southern</option>
                                            <option value="east">Eastern</option>
                                        </select>
                                    </div>

                                    <div style={{ flex: "1 1 18%" }}>
                                        <label className="form-label fw-semibold">District</label>
                                        <select className="form-select">
                                            <option value="">Select District</option>
                                            <option value="lilongwe">Lilongwe</option>
                                            <option value="blantyre">Blantyre</option>
                                            <option value="mzuzu">Mzuzu</option>
                                        </select>
                                    </div>

                                    <div style={{ flex: "1 1 18%" }}>
                                        <label className="form-label fw-semibold">Camp</label>
                                        <select className="form-select">
                                            <option value="">Select Camp</option>
                                            <option value="camp1">Camp 1</option>
                                            <option value="camp2">Camp 2</option>
                                            <option value="camp3">Camp 3</option>
                                        </select>
                                    </div>

                                    <div style={{ flex: "1 1 18%" }}>
                                        <label className="form-label fw-semibold">Species</label>
                                        <select className="form-select">
                                            <option value="">Select Species</option>
                                            <option value="tilapia">Tilapia</option>
                                            <option value="catfish">Catfish</option>
                                            <option value="carp">Carp</option>
                                        </select>
                                    </div>
                                </div>


                            </form>
                        </div>

                        <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="searchBox mt-3">
                                <div className="d-flex justify-content-end">
                                    <div className="form-group">
                                        <input type="text" name="" placeholder="Search" className="form-control h40px" />
                                        <img src="./assets/images/search.png" alt="" />
                                    </div>

                                    <button className="btn btn-cancel mt-3 ms-2" onClick={handleAddNew}>+ Add New </button>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table tbl_new">
                                    <thead>
                                        <tr>
                                            <th>Camp</th>
                                            <th>Species</th>
                                            <th>Max Air Temp</th>
                                            <th>Min Air Temp</th>
                                            <th> Pond Temp </th>
                                            <th>Max Pond Temp </th>
                                            <th>Min Pond Temp</th>
                                            <th>Option</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Tilapia rendalli </td>
                                            <td>--C</td>
                                            <td>--C</td>
                                            <td>--C</td>
                                            <td>--C</td>
                                            <td>--C</td>
                                            <td>
                                                <button className="btn border-0 p-0"><img src="./assets/images/Edit.png" alt="" /></button>
                                                <button className="btn border-0 p-0 ms-5" onClick={handleShow}><img src="./assets/images/delete.png" alt="" /></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={show} onHide={handleClose}
                {...props}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Body>
                    <div className="row">
                        <div className="cl-sm-12 col-md-12 col-lg-12 text-center">
                            <div className="modalBoxNew text-center">
                                <p><img src="./assets/images/trash.png" alt="" height={60} /></p>
                                <h3>Threshold Successfully Deleted</h3>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-2">
                        {/* <button className="btn btnsend me-4">Edit Advisory</button> */}
                        <button className="btn btnsend" onClick={handleClose}>Ok</button>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer> */}
            </Modal>

            <Footer />

        </>
    );
}

export default Threshold;
